import { Injectable, NgZone, signal } from '@angular/core';

import type { InViewportConfig } from './in-viewport-config';

@Injectable()
export class InViewportService {
  public readonly entries = signal<IntersectionObserverEntry[]>([]);

  private observer?: IntersectionObserver;

  constructor(private readonly ngZone: NgZone) {}

  private emitEntries(entries: IntersectionObserverEntry[]) {
    if (Array.isArray(entries) && entries.length) {
      this.entries.set(entries);
    }
  }

  private getRootElement(element?: Element) {
    return element && element.nodeType === Node.ELEMENT_NODE
      ? element
      : undefined;
  }

  public register(target: Element, config: InViewportConfig): void {
    this.ngZone.runOutsideAngular(() => {
      const options: IntersectionObserverInit = {
        root: this.getRootElement(config.root),
        rootMargin: config.rootMargin,
        threshold: config.threshold,
      };
      this.observer = new IntersectionObserver(
        (entries: IntersectionObserverEntry[]) =>
          this.ngZone.run(() => this.emitEntries(entries)),
        options
      );

      if (this.observer && typeof this.observer?.observe === 'function') {
        this.observer.observe(target);
      } else {
        console.warn(
          '[Viewport service] intersection observer cannot be instantiated'
        );
      }
    });
  }

  public unregister(target: Element): void {
    this.ngZone.runOutsideAngular(() => {
      if (this.observer) {
        this.observer.unobserve(target);
        this.observer.disconnect();
        this.observer = undefined;
      }
    });
  }
}
